@use "variables" as *;

.backdrop {
  width: 100%;
  height: 100%;
}
